import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, StatusBadge } from "@/components/app/PageBits";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fmtDate } from "@/lib/api";

export default function PlanRequests() {
  const [list, setList] = useState([]);
  const load = async () => setList((await api.get("/plan-change-requests", { params: { status: "pending" } })).data);
  useEffect(() => { load(); }, []);

  const decide = async (id, decision) => {
    try { await api.post(`/plan-change-requests/${id}/decide`, { decision }); toast.success(decision); load(); }
    catch(e){ toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div>
      <PageHeader title="Plan-change requests" subtitle="Customer-initiated requests are only accepted within the 7-day window after a cycle completes. Admin approvals apply from the next cycle."/>
      <div className="border border-border rounded-md bg-card overflow-hidden">
        <table className="w-full text-sm m-cards">
          <thead className="bg-muted/60"><tr className="text-left">
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Plot</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Customer</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">From</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">To</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Requested</th>
            <th className="px-4 py-3 font-heading text-xs uppercase tracking-wider">Status</th>
            <th className="px-4 py-3"></th>
          </tr></thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} data-testid={`pcr-row-${r.id}`} className="border-t border-border">
                <td className="px-4 py-3 font-medium">{r.plot_no}</td>
                <td className="px-4 py-3">{r.customer_name}</td>
                <td className="px-4 py-3 capitalize">{r.from_plan.replace("_"," ")}</td>
                <td className="px-4 py-3 capitalize">{r.to_plan.replace("_"," ")}</td>
                <td className="px-4 py-3 text-muted-foreground">{fmtDate(r.created_at)}</td>
                <td className="px-4 py-3"><StatusBadge status={r.status}/></td>
                <td className="px-4 py-3 text-right flex gap-1 justify-end">
                  <Button data-testid={`approve-pcr-${r.id}`} size="sm" onClick={()=>decide(r.id,"approved")}>Approve</Button>
                  <Button data-testid={`reject-pcr-${r.id}`} size="sm" variant="outline" onClick={()=>decide(r.id,"rejected")}>Reject</Button>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-muted-foreground">Nothing pending.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
